module.exports = __webpack_public_path__ + "static/img/other.53ec202c.svg";